import { render, staticRenderFns } from "./session-moderators.vue?vue&type=template&id=134c76c6"
import script from "./session-moderators.vue?vue&type=script&lang=ts"
export * from "./session-moderators.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports